var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGarageDashboardIconOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09375 0.78125C2.19172 0.78125 0.625 2.34797 0.625 4.25V12.3438C0.625 19.9947 6.84909 26.2188 14.5 26.2188C22.1509 26.2188 28.375 19.9947 28.375 12.3438V4.25C28.375 2.34797 26.8083 0.78125 24.9062 0.78125H4.09375ZM4.09375 3.09375H24.9062C25.5607 3.09375 26.0625 3.59556 26.0625 4.25V12.3438C26.0625 18.7436 20.8998 23.9062 14.5 23.9062C8.10016 23.9062 2.9375 18.7436 2.9375 12.3438V4.25C2.9375 3.59556 3.43931 3.09375 4.09375 3.09375ZM8.321 8.18819C7.87816 8.18819 7.43069 8.39169 7.09306 8.73047C6.93218 8.88837 6.80438 9.07675 6.71714 9.28461C6.62989 9.49247 6.58496 9.71564 6.58496 9.94106C6.58496 10.1665 6.62989 10.3897 6.71714 10.5975C6.80438 10.8054 6.93218 10.9938 7.09306 11.1517L13.3438 17.4023C13.6698 17.7278 14.1116 17.9105 14.5723 17.9105C15.0329 17.9105 15.4747 17.7278 15.8008 17.4023L21.9069 11.332C22.2324 11.006 22.4151 10.5642 22.4151 10.1035C22.4151 9.64286 22.2324 9.20103 21.9069 8.875C21.5809 8.54957 21.1391 8.3668 20.6784 8.3668C20.2178 8.3668 19.7759 8.54957 19.4499 8.875L14.5728 13.7532L9.55009 8.73047C9.21131 8.39169 8.76384 8.18819 8.321 8.18819Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarageDashboardIconOne);
export default __webpack_public_path__ + "static/media/garage_dashboard_icon_one.77b7d7673e20342257f61ef4300d9bb8.svg";
export { ForwardRef as ReactComponent };